module.exports = require('./_global').document && document.documentElement;


//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/library/modules/_html.js
// module id = 419
// module chunks = 2 92